import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './_guards/auth.guard';
import { PermissionGuard } from './_guards/permission.guard';
import { ReverseAuthGuard } from './_guards/reverse-auth.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/patient-meal-order',
    pathMatch: 'full',
  },
  {
    path: 'patient-meal-order',
    loadChildren: () =>
      import('./patient-meal-order/patient-meal-order.module').then(
        (m) => m.PatientMealOrderModule
      ),
  },
  { path: '**', redirectTo: 'patient-meal-order' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
